<template>
  <section>
    <lecture-list :query="query" />
  </section>
</template>

<script>
import LectureList from '@/components/order_management/LectureList'

export default {
  name: 'Lectures',
  components: {
    LectureList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
